import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CircularProgress, Stack, Pagination } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { useTranslation } from "react-i18next";
import CategoriesApi from "api/categories";
import ActionCell from "./components/ActionCell";
import SoftTypography from "components/SoftTypography";

function MainCategories() {
    const { t } = useTranslation();
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        fetchMainCategories(page);
    }, [page]);

    const fetchMainCategories = (pageNumber) => {
        const token = localStorage.getItem("token");
        if (!token) return;

        setLoading(true);
        CategoriesApi.GetMainCategories(token, pageNumber)
            .then((response) => {
                setCategories(response.data.results || []);
                setTotalPages(Math.ceil(response.data.count / 10) || 1);
            })
            .catch((error) => {
                console.error("Failed to fetch main categories:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const columns = [
        {
            Header: t("Nom"),
            accessor: "main_category_name",
        },
        {
            Header: t("Description"),
            accessor: "description",
        },
        {
            Header: t("Date de création"),
            accessor: "creation_date",
            Cell: ({ value }) => (
                <SoftTypography variant="caption" color="secondary">
                    {value ? new Date(value).toLocaleDateString() : "-"}
                </SoftTypography>
            ),
        },
        {
            Header: t("action"),
            accessor: "id",
            Cell: ({ value }) => (
                <ActionCell id={value} onDataUpdate={() => fetchMainCategories(page)} />
            ),
        },
    ];

    const rows = categories.map((cat) => ({
        main_category_name: cat.main_category_name,
        description: cat.description,
        creation_date: cat.creation_date,
        id: cat.id,
    }));

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <SoftBox my={3}>
                <Stack direction="row" justifyContent="flex-end" mb={2}>
                    <Link to="/gestion-de-stock/main-categories/nouvelle-categorie">
                        <SoftButton variant="gradient" color="info">
                            + {t("Nouvelle catégorie")}
                        </SoftButton>
                    </Link>
                </Stack>
                <Card>
                    {loading ? (
                        <SoftBox display="flex" justifyContent="center" alignItems="center" p={10}>
                            <CircularProgress color="info" />
                        </SoftBox>
                    ) : (
                        <>
                            <DataTable
                                table={{ columns, rows }}
                                entriesPerPage={{
                                    defaultValue: 10,
                                    entries: [5, 10, 15, 20, 25],
                                }}
                                // canSearch
                                showTotalEntries
                                pagination={{ variant: "gradient", color: "info" }}
                            />
                            {totalPages > 1 && (
                                <SoftBox display="flex" justifyContent="center" mt={3} mb={1}>
                                    <Pagination
                                        count={totalPages}
                                        page={page}
                                        onChange={handlePageChange}
                                        color="info"
                                        sx={{
                                            "& .Mui-selected": {
                                                backgroundColor: "white !important",
                                                color: "#f57c00 !important",
                                                border: "1px solid #f57c00 !important",
                                                boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                                            },
                                        }}
                                    />
                                </SoftBox>
                            )}
                        </>
                    )}
                </Card>
            </SoftBox>
            <Footer />
        </DashboardLayout>
    );
}

export default MainCategories;
